import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"
import List from "app/stores/list"

export default class Store {
  @observable shareList = []
  @observable list
  @observable DiagnosisList = []

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/pgd/reports/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action shareGroup = (groupId, username) => {
    return request.put(`${config.backend}/pgd/groups/${groupId}/share/${username}`)
      .checkToken()
      .commonDispose()
  }

  @action batchShareGroup = (body) => {
    return request.put(`${config.backend}/pgd/groups/share/batch`)
      .send(body)
      .checkToken()
      .commonDispose()
  }

  @action getHistory = (groupId) => {
    return request.get(`${config.backend}/pgd/family/${groupId}/history`)
      .checkToken()
      .commonDispose()
  }

  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/pgd/groups/${groupId}/reports?${query}`)
      .checkToken()
      .commonDispose()
  }

  @action getTaskDatas = (familyId, taskId) => {
    return request.get(`${config.backend}/pgd/family/${familyId}/tasks/${taskId}/datas`)
      .checkToken()
      .commonDispose()
  }

  @action setTaskDatas = (index, id, data) => {
    const rowIndexInCard = this.list.tableData[index].reportList.findIndex(item => item.id === id)
    this.list.tableData[index].reportList[rowIndexInCard].datas = data
  }

  @action updateRemarks = (familyId, taskId, remark) => {
    return request.put(`${config.backend}/pgd/family/${familyId}/tasks/${taskId}`)
      .send({ remark })
      .checkToken()
      .commonDispose()
  }

  @action getShareList = (id) => {
    return request.get(`${config.backend}/pgd/groups/${id}/share`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.shareList = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action deleteReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/pgd/groups/${groupId}/reports/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action cancelShare = (groupId, ownerId, type) => {
    if (type === 'toId') {
      return request.delete(`${config.backend}/pgd/groups/${groupId}/share?${type}=${ownerId}`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            const index = this.shareList.findIndex(
              shared => {
                return shared.toId === ownerId
              }
            )
            this.shareList.splice(index, 1)
            message.success("取消分享成功")
            return Promise.resolve()
          },
          err => {
            message.error(err.message)
            return Promise.reject()
          }
        )
    } else {
      return request.delete(`${config.backend}/pgd/groups/${groupId}/share`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            this.list.filterData()
            message.success("取消分享成功")
            return Promise.resolve()
          },
          err => {
            message.error(err.message)
            return Promise.reject()
          }
        )
    }
  }

  @action deleteDiagnosisReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/pgd/reports/test/delete/${reportId}`)
      .checkToken()
      .commonDispose()
  }
    /*
   * @query: 获取诊断报告列表
   */
    @action getGroupDiagnosisListById = (groupId, query) => {
      return request.get(`${config.backend}/pgd/reports/test/list/${groupId}?status=${query}`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            this.DiagnosisList = res
          }
        )
    }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "pgd/groups/reports")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/pgd/report.js